import ListeUser from "./components/ListeUser";

const index = () => {
  return (
    <div className="flex justify-center w-full mt-10">
      <div className=" shadow-brown drop-shadow-lg">
        <div className="flex justify-center ">
          <ListeUser />
        </div>
      </div>
    </div>
  );
};

export default index;
